import axios from 'axios';

axios.defaults.headers.common['Content-Type'] = 'application/json';

const api = axios.create({
    baseURL: 'https://api.poketask.fr/api', // Ensure this matches your backend URL
    headers: {
        'Content-Type': 'application/json',
        'Content-Type': 'application/merge-patch+json'
    },
    
});

// Request interceptor to add JWT token to headers
api.interceptors.request.use((config) => {
    const jwtToken = localStorage.getItem('jwtToken');
    if (jwtToken) {
        config.headers['Authorization'] = `Bearer ${jwtToken}`;

    }
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
    }
    console.log('Requête envoyée :', config);
    return config;
}, (error) => { 
    return Promise.reject(error);
});

// API functions
export const getUtilisateurs = () => api.get('/utilisateurs');
export const createUtilisateur = (data) => api.post('/utilisateurs', data);

export const getTasks = async (filters = {}) => {
    console.log('getTasks appelé avec les filtres:', filters);
    const params = new URLSearchParams(filters).toString();
    const url = `/tasks?${params}`;
    console.log('URL complète:', url);
    
    try {
        const response = await api.get(url);
        console.log('Réponse brute getTasks:', response);
        return response;
    } catch (error) {
        console.error('Erreur dans getTasks:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            url: url
        });
        throw error;
    }
};


export const createTask = async (data) => {
    console.log('createTask - données envoyées:', data);
    try {
        const token = localStorage.getItem('jwtToken');
        console.log('Token utilisé:', token ? 'présent' : 'absent');
        
        const response = await api.post('/tasks', data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        console.log('Réponse création tâche:', response.data);
        return response.data;
    } catch (error) {
        console.error('Erreur création tâche:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            data: data
        });
        throw error;
    }
};


export const updateExperience = async (userPokemonId, experience) => {
    try {
      const response = await api.patch(`/user_pokemons/${userPokemonId}/experience`, 
        { experience },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating experience:', error);
      throw error;
    }
  };
  
export const updateLvl = async (userPokemonId, lvl) => {
    try {
      const response = await api.patch(`/user_pokemons/${userPokemonId}/lvl`, 
        { lvl },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating lvl:', error);
      throw error;
    }
  };
  
// Removed getExperiencePoints as it's not an API call



export const deleteTask = (taskId) => {
    return api.delete(`/tasks/${taskId}`);
};

export const getPokemons = () => api.get('/pokemons');
export const getUserPokemons = async () => {
    try {
        const response = await api.get('/user_pokemons');
        console.log('Réponse getUserPokemons:', response.data);
        return response.data;
    } catch (error) {
        console.error('Erreur getUserPokemons:', error);
        throw error;
    }
};

export const createPokemon = (data) => api.post('/pokemon', data);

export default api;